// Copyright ©️ 2026 eVolve MEP, LLC

import type { Task, WorkCellTask } from '@evolvemep/api-ts';

import type { WithOptional } from 'helpers/helper-types';
import { isNil, isNotNil } from 'helpers/isNotNil';
import { getDaysRemainingOrDaysEarlyLate } from 'modules/Shop/WorkOrders/WorkOrdersPage/common';

export const getDaysRemainingWorkCellTask = (
  workCellTask: WithOptional<
    Pick<WorkCellTask, 'taskStatusTypeName' | 'needByDate' | 'taskStatusTypeUpdatedOn'>,
    'taskStatusTypeUpdatedOn'
  >,
) =>
  getDaysRemainingOrDaysEarlyLate(
    workCellTask.needByDate,
    workCellTask.taskStatusTypeName === 'Completed' && isNotNil(workCellTask.taskStatusTypeUpdatedOn)
      ? workCellTask.taskStatusTypeUpdatedOn
      : undefined,
  );

/**
 * Whether a task can be sent back to not started. Only a completed task that was never started qualifies, since no
 * time has accrued against it — a completed task that ran is reopened by resuming it instead.
 */
export const canUncompleteTask = (task: Pick<Task, 'taskStatusTypeName' | 'dateStarted'>) =>
  task.taskStatusTypeName === 'Completed' && isNil(task.dateStarted);
